module.exports = __webpack_public_path__ + "img/a7.7bafc018.jpg";